'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment, useCallback } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import uniqid from 'uniqid';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import { default_booking_form_store } from 'Stores/BookingFormStore';
import BookingFormStore from 'Stores/BookingFormStore';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import TextInput from 'Components/Forms/Elements/TextInput';
import FullScreenModal from 'Modals/FullScreenModal';
import Slider from 'Components/Slider';
import FrontSpaceSchedule from 'Components/Front/FrontSpaceSchedule';
import SpaceAvailability from 'Components/Front/SpaceAvailability';
import BookingRange from 'Components/Front/BookingRange';
import Loader from 'Pure/Loader';
import Image from 'Pure/Image';
import Link from 'Pure/Link';
import Logo from 'Pure/Logo';
import resetStorageBookingValues from 'Functions/resetStorageBookingValues';
import getBookingIdentifier from 'Functions/getBookingIdentifier';
import isInViewport from 'Functions/isInViewport';
import scrollToNode from 'Functions/scrollToNode';
import variant from 'Functions/variant';
import bemit from 'Functions/bemit';
import PeopleIcon from 'Icons/People';
import PhotoIcon from 'Icons/PhotoIcon';
import { space as space_icons } from 'Components/IconsConfigs';
import { coworking_place_types, days_config, b_seminar_ranges } from 'Shared/options';
import { safeNumeral, getSpaceAmount, formatNum, isTrue } from 'Shared/utilities';
import { getSpacedPhoneNumber, getOpenInfos, num, isAfterDelta } from 'Shared/utilities';
import { action, URL } from 'Shared/Routes';
import { ALLOWED_MIN_OVERFLOW } from 'Shared/config';
numeral.locale('en');
const app = window.app;
const qwest = window.qwest;
const b_seminars_config = {
  'u': {
    title: 'Disposition en U',
    name: 'u',
    short_title: 'U'
  },
  'classe': {
    title: 'Disposition en classe',
    name: 'classe',
    short_title: 'Classe',
    icon: space_icons.find(config => config.value === 'Vidéoprojection')?.icon
  },
  'board': {
    title: 'Disposition en table ronde',
    name: 'board',
    short_title: 'Table ronde',
    icon: space_icons.find(config => config.value === 'Paperboard')?.icon
  },
  'theater': {
    title: 'Disposition en théâtre',
    name: 'theater',
    short_title: 'Théâtre',
    icon: space_icons.find(config => config.value === 'theater')?.icon
  },
  'island': {
    title: 'Disposition en îlots',
    name: 'island',
    short_title: 'Îlots',
    icon: space_icons.find(config => config.value === 'Island')?.icon
  }
};
const MAX_HEIGHT = 100;
export default function CoworkingSpaceWrapper(props) {
  const reset = useCallback(function (e) {
    BookingFormStore.update(s => default_booking_form_store);
  }, []);
  return /*#__PURE__*/React.createElement(CoworkingSpace, _extends({}, props, {
    onBooking: reset
  }));
}
class CoworkingSpace extends Component {
  state = function () {
    const props = this.props;
    const state = {
      loading: false,
      closed: false,
      people: window.localStorage.getItem('widget-people') || '',
      date: window.localStorage.getItem('widget-date') || '',
      amount: window.localStorage.getItem('amount') || '',
      disposition: window.localStorage.getItem('widget-disposition') || '',
      pending_booking: window.localStorage.getItem('current_booking_id') ? true : false,
      start: '',
      end: '',
      desc_expanded: false,
      description_style: {
        maxHeight: MAX_HEIGHT
      },
      modal: false,
      status_messages: {}
    };
    if (isTrue(props['init-from-props']) && props.date) {
      state.date = props.date;
    }
    return state;
  }.bind(this)();
  requests = {};
  desc_ref = React.createRef();
  modal_ref = React.createRef();
  scroll_to_ref = React.createRef();
  fetchs = 0;
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'UpdatedSideWidget',
      cb: component.handleWidgetChange
    });
    app.push({
      event: 'window.resize',
      cb: component.handleResize
    });
    let slider_imgs;
    if (props.images?.length > 1) {
      slider_imgs = props.images.map(function (image) {
        let data = {
          alt: image.alt || image.title,
          src: variant({
            img: image,
            size: 1920,
            ratio: '16:9'
          }),
          id: uniqid()
        };
        return data;
      });
    }
    component.setState({
      slider_imgs
    });
    component.fetchAvailability({});
  }
  openModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: true,
      modal_trg: e?.target
    });
  };
  closeModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: false,
      modal_trg: undefined
    });
  };
  componentDidUpdate(prevProps, prevState) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prevState.date !== state.date) {
      component.fetchAvailability({});
    }
    if (prevProps.date !== props.date) {
      component.setState({
        date: props.date
      });
      component.fetchAvailability({
        date: props.date
      });
    } else if (prevProps.people !== props.people) {
      component.setState({
        people: props.people
      });
      component.fetchAvailability({
        people: props.people
      });
    }
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'UpdatedSideWidget',
      cb: component.handleWidgetChange
    });
    Object.keys(component.requests).forEach(name => component.requests[name]?.abort());
    component.requests = {};
  }
  handleDateChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      date: value
    });
    window.localStorage.setItem('widget-date', value);
    app.emit({
      event: 'UpdateSideWidgetDate'
    });
  };
  handleResize = ({
    source
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.desc_expanded === true) return;
    if (props.description?.length > 0 === false) return;
    if (!component.desc_ref?.current) return;
    const description = component.desc_ref.current.querySelector('.js-description');
    if (!description) return;
    const height = description.getBoundingClientRect().height;
    if (height > 0 === false) {
      return window.requestAnimationFrame(function () {
        component.handleResize({
          source: 'handleResize'
        });
      });
    }
    if (height > MAX_HEIGHT && state.desc_expanded !== true) {
      component.setState({
        more_desc_btn: true
      });
    }
  };
  handleSeatChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (component.search_timeout) {
      window.clearTimeout(component.search_timeout);
      component.fetchs -= 1;
    }
    component.fetchs += 1;
    component.search_timeout = window.setTimeout(function () {
      component.search_timeout = undefined;
      component.fetchAvailability({
        date: state.date,
        people: window.localStorage.getItem('widget-people'),
        fetchs: true
      });
    }, 400);
    component.setState({
      people: value
    });
    window.localStorage.setItem('widget-people', value);
  };
  handleDispositionChange = e => {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      value,
      name
    } = e?.target || {};
    let too_little_seats = false;
    const available_seats = safeNumeral(props.disposition_seat?.[value]?.place);
    if (state.people > 0) {
      too_little_seats = parseInt(state.people) > available_seats;
    }
    component.setState({
      disposition: value,
      seminar_too_little_seats: too_little_seats
    });
    window.localStorage.setItem('widget-disposition', value);
  };
  addDay = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!state.date) return;
    const new_date = moment(state.date).add(1, 'day').format('YYYY-MM-DD');
    component.setState({
      date: new_date
    });
    let amount = getSpaceAmount({
      pricings: props.pricings,
      disposition_seat: props.disposition_seat,
      schedule_price: props.schedule_price,
      space_type: props.type,
      people: state.people,
      date: new_date,
      start_hour: state.start,
      end_hour: state.end,
      roles: app?.state?.session?.user?.roles?.[0]
    });
    component.setState({
      amount: amount
    });
    window.localStorage.setItem('amount', amount);
    window.localStorage.setItem('widget-date', new_date);
    app.emit({
      event: 'UpdateSideWidgetDate'
    });
  };
  removeDay = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!state.date || moment().isSame(state.date, 'day')) {
      return;
    }
    const new_date = moment(state.date).subtract(1, 'day').format('YYYY-MM-DD');
    component.setState({
      date: new_date
    });
    let amount = getSpaceAmount({
      pricings: props.pricings,
      disposition_seat: props.disposition_seat,
      schedule_price: props.schedule_price,
      space_type: props.type,
      people: state.people,
      date: new_date,
      start_hour: state.start,
      end_hour: state.end,
      roles: app?.state?.session?.user?.roles?.[0]
    });
    component.setState({
      amount: amount
    });
    window.localStorage.setItem('amount', amount);
    window.localStorage.setItem('widget-date', new_date);
    app.emit({
      event: 'UpdateSideWidgetDate'
    });
  };
  requestCustomerDate = e => {
    app.emit({
      event: 'ShowCustomerWidgetDate'
    });
  };
  handleWidgetChange = ({
    data = {},
    source
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.pending_booking && window.localStorage.getItem('booking-space-id') !== props.id) {
      return;
    }
    if (state.pending_booking) {
      return component.setState({
        people: window.localStorage.getItem('widget-people'),
        date: window.localStorage.getItem('widget-date'),
        amount: window.localStorage.getItem('current_booking_price')
      });
    }
    const people = window.localStorage.getItem('widget-people');
    const date = window.localStorage.getItem('widget-date');
    component.setState({
      people: people,
      date: date
    });
    let amount = getSpaceAmount({
      pricings: props.pricings,
      disposition_seat: props.disposition_seat,
      schedule_price: props.schedule_price,
      space_type: props.type,
      people: people || state.people,
      date: date || state.date,
      start_hour: state.start,
      end_hour: state.end,
      roles: app?.state?.session?.user?.roles?.[0]
    });
    component.setState({
      amount: amount
    });
    window.localStorage.setItem('amount', amount);
    if (date) {
      component.fetchAvailability({
        date,
        people
      });
    }
    if (data?.scrollToAvailability) {
      component.handleScrollRequest();
    }
  };
  handleScrollRequest = () => {
    const list = document.getElementById('spaces-block-list');
    if (isInViewport(list)) return; // liste déjà visible

    const tabs = document.querySelector('.js-establishment-tabs');
    const tabs_height = tabs ? tabs.getBoundingClientRect().height : 54;
    const target = document.getElementById('info');
    if (!target || !target.scrollIntoView) return;
    scrollToNode({
      node: target,
      offset: tabs_height || 54,
      force: true
    });
  };
  fetchAvailability = ({
    date,
    people,
    fetchs = false
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!date && !state.date) return;
    const people_count = typeof people === 'undefined' ? parseInt(safeNumeral(state.people)) : parseInt(safeNumeral(people));
    component.setState({
      availability_loading: true,
      date: date || state.date
    });
    let amount = getSpaceAmount({
      pricings: props.pricings,
      disposition_seat: props.disposition_seat,
      schedule_price: props.schedule_price,
      space_type: props.type,
      people: people || state.people,
      date: moment(date || state.date).format('YYYY-MM-DD'),
      start_hour: state.start,
      end_hour: state.end,
      roles: app?.state?.session?.user?.roles?.[0]
    });
    if (amount > 0) {
      component.setState({
        amount: amount
      });
      window.localStorage.setItem('amount', amount);
    }
    const date_value = date || state.date;
    if (component.requests['fetchAvailability']) {
      component.requests['fetchAvailability']?.abort();
      delete component.requests['fetchAvailability'];
    }
    const seats = numeral(safeNumeral(props.number_seat)).format('0');
    const day = days_config[moment(date_value).isoWeekday() - 1];
    const [is__open, is__custom] = getOpenInfos({
      schedule: props.schedule,
      availability: props.availabilities,
      type: props.type,
      date: date_value
    });
    if (!is__open) {
      return component.setState({
        availability_loading: false,
        special_closing: is__custom,
        closed: true,
        start: '',
        end: ''
      });
    }
    const req = qwest.post(action('getSpaceBooking'), {
      coworking_space_id: props.id,
      date: date_value
    }).then(function (xhr, response) {
      if (!component.requests['fetchAvailability']) return;
      if (component.requests['fetchAvailability'] !== req) return;
      delete component.requests['fetchAvailability'];
      if (fetchs) component.fetchs -= 1;
      numeral.locale('en');
      moment.locale('fr');
      component.setState({
        availability_loading: false,
        closed: false
      });
      let availability = [];
      if (props.type === 'a_calm_coworking_space') {
        const schedule = props.schedule[day] || {};
        let from = schedule.from;
        const delta = num(props.cancel_h_delta);
        if (moment().isSame(date_value, 'day')) {
          const allow_current = delta === 0 && moment().minute() <= ALLOWED_MIN_OVERFLOW;
          const next_hour = allow_current ? moment().hour() : moment().add(1, 'hours').hour();

          // l'heure de début du planning est déjà écoulée
          if (from < next_hour) {
            from = next_hour;
          }
        }
        let hours_range = numeral(safeNumeral(schedule.to)).subtract(safeNumeral(from)).value();
        availability.length = hours_range;
        availability = Array.from(availability).map(function (nothing, i) {
          const start_hour = numeral(safeNumeral(from)).add(i).format('0');
          const infos = {
            start: start_hour,
            end: numeral(start_hour).add(1).format('0')
          };
          const is__expired = isAfterDelta({
            date: date_value,
            hour: start_hour,
            delta,
            overflow: ALLOWED_MIN_OVERFLOW
          });
          if (is__expired) {
            infos.delta_expired = true;
          }
          const booking_infos = response.booking.find(booking => booking.hour === start_hour);
          infos.remaining_seats = numeral(seats).subtract(safeNumeral(booking_infos?.people_count)).format('0');
          if (infos.remaining_seats < 0) infos.remaining_seats = '0';
          infos.too_little_seats = infos.remaining_seats < people_count;
          return infos;
        });
        component.setState({
          availability: availability,
          start: availability.some(infos => infos.start === state.start) ? state.start : '',
          end: availability.some(infos => infos.end === state.end) ? state.end : ''
        });
      } else {
        const bookings = response.booking || [];
        availability = b_seminar_ranges.filter(opt => opt.value !== 'day').map(function (config, i) {
          const infos = {
            start: config.value
          };
          const [is__open, is__custom] = getOpenInfos({
            schedule: props.schedule,
            availability: props.availabilities,
            type: props.type,
            date: date_value,
            period: config.value
          });
          infos.available = is__open;
          infos.is_open = is__open;
          infos.is_custom = is__custom;
          const day_name = days_config[moment(state.date).isoWeekday() - 1];
          const schedule = props.schedule?.[day_name] || {};
          let start_hour = config.value === 'afternoon' ? num(schedule.afternoon_from, 0) : num(schedule.morning_from, 0);
          const delta = num(props.cancel_h_delta, 0);
          if (isAfterDelta({
            date: date_value,
            hour: start_hour,
            delta
          })) {
            infos.delta_expired = true;
          }
          const from = schedule[config.value + '_from'];
          const to = schedule[config.value + '_to'];
          if (from && to && from !== to) {
            infos.hours_range = from + 'h' + '-' + to + 'h';
          }
          if (props.type === 'c_open_coworking_space') {
            const booking_infos = bookings.filter(booking => booking.type === config.value);
            infos.remaining_seats = numeral(safeNumeral(seats));
            booking_infos.forEach(function (booking) {
              infos.remaining_seats.subtract(safeNumeral(booking?.people_count));
            });
            infos.remaining_seats = infos.remaining_seats.format('0');
            if (infos.remaining_seats > 0 === false) {
              infos.remaining_seats = '0';
            }
            infos.too_little_seats = infos.remaining_seats < people_count;
          } else if (bookings?.[0]?.type === 'day') {
            infos.available = false;
            infos.full = true;
          } else {
            if (is__custom && !is__open) {
              infos.available_type = 'close';
            }
            if (is__open) {
              const booking = bookings.find(booking => booking.type === config.value);
              infos.available = !booking;
              if (!infos.available) infos.full = true;
            }
          }
          return infos;
        });
        let start = state.start;
        if (start) {
          let is__valid = false;
          if (start === 'day') {
            is__valid = availability.every(infos => infos.available);
          } else {
            is__valid = availability.some(infos => infos.start === start && infos.available);
          }
          if (is__valid === false) {
            start = '';
          }
        }
        let too_little_seats = false;
        if (state.disposition && people) {
          too_little_seats = parseInt(people, 10) > parseInt(props.disposition_seat[state.disposition]?.place, 10);
        }
        component.setState({
          availability: availability,
          start: start,
          seminar_too_little_seats: too_little_seats
        });
      }
    }).catch(function (error, xhr, response) {
      if (!component.requests['fetchAvailability']) return;
      if (component.requests['fetchAvailability'] !== req) return;
      delete component.requests['fetchAvailability'];
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        }),
        availability_loading: false
      });
    });
    component.requests['fetchAvailability'] = req;
  };
  requestBooking = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.onBooking) props.onBooking(e);

    // Clear previous booking fields if they were not
    resetStorageBookingValues();

    // Set new booking fields
    window.localStorage.setItem('booking-space-id', props.id);
    window.localStorage.setItem('widget-start', state.start);
    window.localStorage.setItem('widget-end', state.end);
    window.localStorage.setItem('widget-date', state.date);
    window.localStorage.setItem('amount', formatNum(state.amount, '0.00'));
    if (!isTrue(props.have_services)) {
      window.localStorage.setItem('services_picked', getBookingIdentifier());
    }
    if (props.source === 'offline') {
      return props.selectSpace();
    }
    if (props['white-label-booking'] === true) {
      return app.emit({
        event: 'StartWhiteLabelBooking',
        source: 'CoworkingSpace.requestBooking'
      });
    }
    app.navigateTo(URL('FrontBookingPage'));
  };
  handleRangeChange = ({
    start,
    end,
    too_little_seats
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let update = {};
    if (start) {
      update.start = start;
    }
    if (end) {
      update.end = end;
    }
    if (typeof too_little_seats !== 'undefined') {
      update.too_little_seats = too_little_seats;
    }
    let seminar_too_little_seats = false;
    if (state.people && state.disposition) {
      seminar_too_little_seats = parseInt(state.people, 10) > parseInt(props.disposition_seat[state.disposition]?.place, 10);
    }
    component.setState({
      seminar_too_little_seats: seminar_too_little_seats
    });
    let amount = getSpaceAmount({
      pricings: props.pricings,
      disposition_seat: props.disposition_seat,
      schedule_price: props.schedule_price,
      space_type: props.type,
      people: state.people,
      date: state.date,
      start_hour: start || state.start,
      end_hour: end || state.end,
      roles: app?.state?.session?.user?.roles?.[0]
    });
    component.setState({
      amount: amount
    });
    window.localStorage.setItem('amount', amount);
    component.setState(update);
  };
  toggleDesc = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      desc_expanded: true
    });
  };
  collapseDesc = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      desc_expanded: false
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const payment_enabled = isTrue(props._etablishment?.has_payment);
    const user_roles = app.state.session?.user?.roles || [];
    const modifiers = [].concat(props.bemit || []);
    const availability_loader = state.availability_loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }) : undefined;
    let link = '/' + ['etablissements', props._etablishment?.slug, props.slug].join('/');
    const phone_number = getSpacedPhoneNumber(props._etablishment?.phone_number);
    let payment_not_enabled_msg = payment_enabled ? undefined : /*#__PURE__*/React.createElement("p", {
      className: "payment-not-enabled-info"
    }, "Veuillez contacter l'\xE9tablissement pour toute r\xE9servation", phone_number?.length > 4 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), "T\xE9l\xE9phone\xA0: ", phone_number) : undefined);
    const description = /*#__PURE__*/React.createElement("div", {
      className: "front-etablishment-description",
      ref: component.desc_ref
    }, /*#__PURE__*/React.createElement("div", {
      className: "front-space-description",
      dangerouslySetInnerHTML: {
        __html: props.description
      }
    }));
    let availability;
    if (props.availability === true) {
      const picker_tool_modifiers = [];
      if (state.date && moment().isSame(state.date, 'day')) {
        picker_tool_modifiers.push('tomorrow');
      } else if (!state.date) {
        picker_tool_modifiers.push('no-date');
      }
      let b_seminars_disposition_input;
      let closed_label = 'Fermé'.toUpperCase();
      if (state.special_closing !== true) {
        closed_label = 'NON DISPONIBLE';
      }
      const is__half_type = ['b_seminar', 'c_open_coworking_space'].includes(props.type);
      const is__free = props.type === 'c_open_coworking_space';
      const company_employee_connected = (app.state.session?.user?.roles || []).includes('company_employee') && props.type === 'b_seminar';
      let too_many_people = false,
        too_few_people = false;
      let booking_btn_label = is__free ? 'Réserver' : payment_enabled ? 'Réserver pour ' : 'Tarif indicatif : ';
      if (!is__free) {
        booking_btn_label += state.amount > 0 === false ? '' : formatNum(state.amount, '0,0[.]00');
      }
      let booking_btn_suffix = '';
      if (state.amount && !is__free) {
        booking_btn_suffix = user_roles.includes('company_employee') ? ' crédits' : '€';
      }
      if (is__half_type) {
        const max_per_booking = props.disposition_seat[state.disposition]?.place;
        if (max_per_booking > 0) {
          too_many_people = numeral(safeNumeral(max_per_booking)).subtract(safeNumeral(state.people)).value() < 0;
          if (too_many_people === true) {
            if (max_per_booking > 0 === false) {
              booking_btn_label = 'Aucune place dispo.';
            } else {
              booking_btn_label = 'Max ' + numeral(safeNumeral(max_per_booking)).format('0') + ' p.';
              booking_btn_suffix = '';
            }
          }
        } else if (props.type === 'c_open_coworking_space') {
          const availability = (state.availability || []).find(infos => infos.start === state.start);
          if (availability?.too_little_seats) {
            if (availability.remaining_seats > 0 === false) {
              booking_btn_label = 'Aucune place dispo.';
            } else {
              booking_btn_label = 'Max ' + numeral(safeNumeral(availability.remaining_seats)).format('0') + ' p.';
            }
          }
        }
        if (!state.start) {
          booking_btn_label = 'Choisissez un créneau';
          booking_btn_suffix = '';
        }
        b_seminars_disposition_input = Object.keys(b_seminars_config).filter(name => props.disposition_seat?.[name]?.place > 0).map(function (name) {
          const config = b_seminars_config[name];
          const Icon = config.icon;
          const id = props.id + config.short_title;
          const output = /*#__PURE__*/React.createElement("div", {
            className: "c-booking-range__radio-container",
            key: config.name
          }, /*#__PURE__*/React.createElement(Button, {
            htmlFor: id,
            component: "label",
            className: "c-booking-range__label"
          }, /*#__PURE__*/React.createElement(Radio, {
            checked: state.disposition === config.name,
            className: "c-booking-range__radio",
            onChange: component.handleDispositionChange,
            value: config.name,
            name: "disposition",
            id: id
          }), /*#__PURE__*/React.createElement("div", {
            className: "c-media__icon",
            key: name,
            "data-hover": config.short_title
          }, Icon ? /*#__PURE__*/React.createElement(Icon, {
            className: "c-media__icon-svg"
          }) : /*#__PURE__*/React.createElement("div", {
            className: 'c-media__seats-icon ' + name
          }, b_seminars_config[name].short_title))));
          return output;
        });
      } else if (props.type === 'a_calm_coworking_space') {
        const min = safeNumeral(props.min_max_seats?.min);
        const max = safeNumeral(props.min_max_seats?.max);
        if (max > 0) {
          too_many_people = numeral(max).subtract(safeNumeral(state.people)).value() < 0;
        }
        if (too_many_people === true) {
          booking_btn_label = 'Max ' + numeral(max).format('0') + ' p.';
          booking_btn_suffix = '';
        }
        if (min > 0) {
          too_few_people = numeral(min).subtract(safeNumeral(state.people)).value() > 0;
        }
        if (too_few_people === true) {
          booking_btn_label = 'Min ' + numeral(min).format('0') + ' p.';
          booking_btn_suffix = '';
        }
        if (!state.start || !state.end) {
          booking_btn_label = 'Choisissez un créneau';
          booking_btn_suffix = '';
        }
      }
      let booking_btn_disabled = false;
      if (is__half_type) {
        booking_btn_disabled = !state.date || !state.start || state.people > 0 === false;
        if (!booking_btn_disabled && props.type === 'b_seminar') {
          booking_btn_disabled = !state.disposition;
        }
      } else {
        booking_btn_disabled = !state.start || !state.end || !state.people || too_few_people || too_many_people;
      }
      if (booking_btn_disabled === false && state.too_little_seats === true) {
        booking_btn_disabled = true;
      }
      if (props.type === 'a_calm_coworking_space' && parseInt(props.max_number_seat, 10) < parseInt(state.people, 10)) {
        booking_btn_disabled = true;
      }
      if (props.type === 'b_seminar' && state.seminar_too_little_seats === true) {
        booking_btn_disabled = true;
      }
      if (parseInt(state.people, 10) > 0 === false) {
        booking_btn_disabled = true;
      }
      if (state.availability_loading || component.fetchs > 0) {
        booking_btn_disabled = true;
      }
      if (props.type === 'c_open_coworking_space') {
        const availability = (state.availability || []).find(infos => infos.start === state.start);
        if (availability?.too_little_seats) {
          booking_btn_disabled = true;
        }
      }
      const booking_btn_bemit = ['front', 'blue'];
      if (booking_btn_disabled) booking_btn_bemit.push('disabled');
      const btn_loader = component.fetchs > 0 ? /*#__PURE__*/React.createElement(Loader, {
        className: "c-loader",
        bemit: ['white', 'bg-blue']
      }) : undefined;
      let is__expired = false;
      if (!state.availability_loading) {
        if (state.start === 'day') {
          is__expired = (state.availability || []).some(infos => infos.delta_expired);
        } else {
          const availability = (state.availability || []).find(infos => infos.start === state.start);
          is__expired = (state.availability || []).every(i => i.delta_expired);
          if (!is__expired) {
            is__expired = availability?.delta_expired ? true : false;
          }
        }
      }
      const hide_seats = [state.closed, !state.date, state.date && state.availability?.length > 0 === false, props.type === 'b_seminar' && !state.disposition, company_employee_connected, is__expired].some(condition => condition);
      const layouts_section = !is__expired && state.date && state.availability?.length > 0 && !state.closed && props.type === 'b_seminar' && !company_employee_connected ? /*#__PURE__*/React.createElement("div", {
        className: "c-booking-range c-booking-range--layout"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-booking-range__content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-booking-range__element"
      }, /*#__PURE__*/React.createElement("label", {
        className: "c-booking-range__label"
      }, "Disposition"), /*#__PURE__*/React.createElement("div", {
        className: "c-booking-range__b_seminar-range"
      }, b_seminars_disposition_input)))) : undefined;
      const seats_input_section = hide_seats ? undefined : /*#__PURE__*/React.createElement("div", {
        className: "c-side-widget__element people"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: state.people_id,
        className: "c-side-widget__label"
      }, "Si\xE8ge(s)"), /*#__PURE__*/React.createElement("div", {
        className: "c-side-widget__container"
      }, /*#__PURE__*/React.createElement(TextInput, {
        className: "c-side-widget__input",
        name: "people",
        onChange: component.handleSeatChange,
        value: state['people'],
        status: state.status_messages,
        "safe-value": true,
        int: true,
        inputMode: "numeric",
        min: "1"
      })));
      const booking_btn_section = is__expired ? /*#__PURE__*/React.createElement("div", {
        className: bemit('c-message', ['grey']) + ' u-margin-top-30 u-margin-bottom-10 u-content-center'
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-message__content u-text-center"
      }, "Espace indisponible")) : state.date && state.availability?.length > 0 && !state.closed && !company_employee_connected ? /*#__PURE__*/React.createElement("div", {
        className: "u-text-center"
      }, payment_enabled || is__free ? /*#__PURE__*/React.createElement(Button, {
        onClick: component.requestBooking,
        className: bemit('c-flat-btn', booking_btn_bemit) + ' u-margin-top-10',
        disabled: booking_btn_disabled
      }, booking_btn_label, booking_btn_suffix, component.fetchs > 0 ? btn_loader : undefined) : /*#__PURE__*/React.createElement("div", {
        className: "booking-btn-replacement"
      }, booking_btn_label, booking_btn_suffix, component.fetchs > 0 ? btn_loader : undefined, payment_not_enabled_msg)) : undefined;
      availability = /*#__PURE__*/React.createElement("div", {
        className: "c-media__availability"
      }, !state.date ? /*#__PURE__*/React.createElement("div", {
        className: "c-media__special-title"
      }, "Disponibilit\xE9s") : /*#__PURE__*/React.createElement("div", {
        className: "c-media__date-picker"
      }, /*#__PURE__*/React.createElement("div", {
        className: bemit('c-picker-tool', picker_tool_modifiers)
      }, /*#__PURE__*/React.createElement(Button, {
        className: "c-picker-tool__less",
        onClick: component.removeDay,
        disabled: !state.date
      }, "- 1 jour"), /*#__PURE__*/React.createElement(DatePicker, {
        value: state.date,
        onChange: component.handleDateChange,
        name: props.id + '-date',
        "allow-no-value": true,
        "no-past": true,
        "no-today": true,
        status: state.status_messages,
        "btn-class": "c-picker-tool__btn",
        className: "u-margin-bottom-0"
      }), /*#__PURE__*/React.createElement(Button, {
        className: "c-picker-tool__more",
        onClick: component.addDay,
        disabled: !state.date
      }, "+ 1 jour"))), /*#__PURE__*/React.createElement("div", {
        className: "c-media__availability-content",
        ref: component.scroll_to_ref
      }, company_employee_connected ? /*#__PURE__*/React.createElement("div", {
        className: "c-space-closed"
      }, "Vous ne pouvez pas r\xE9server ce type d'espace avec votre compte") : undefined, !state.date && !company_employee_connected ? /*#__PURE__*/React.createElement(Button, {
        onClick: component.requestCustomerDate,
        className: bemit('c-flat-btn', ['front', 'space-availability'])
      }, "Choisissez une date") : undefined, state.closed === true && state.date ? /*#__PURE__*/React.createElement("div", {
        className: "c-space-closed"
      }, closed_label) : state.date && state.availability?.length > 0 && !state.closed && !company_employee_connected && props.type === 'a_calm_coworking_space' ? /*#__PURE__*/React.createElement(SpaceAvailability, {
        data: state.availability,
        type: props.type,
        schedule: props.schedule
      }) : undefined, state.date && state.availability?.length < 1 && !state.closed ? /*#__PURE__*/React.createElement("div", {
        className: "c-space-closed"
      }, "Aucun horaire disponible") : undefined, !(is__expired && is__half_type) && state.date && state.availability?.length > 0 && !state.closed && !company_employee_connected ? /*#__PURE__*/React.createElement(BookingRange, {
        type: props.type,
        status_messages: state.status_messages,
        onChange: component.handleRangeChange,
        availability: state.availability,
        start: state.start,
        end: state.end
      }) : undefined, layouts_section, seats_input_section, booking_btn_section, availability_loader));
    }
    if (props['layout-type'] === 'side') {
      modifiers.push('side');
      const type = coworking_place_types.find(infos => infos.value === props.type);
      const icons = space_icons.filter(infos => (props.equipments || []).includes(infos.value)).map(function (infos) {
        const Icon = infos.icon;
        const output = /*#__PURE__*/React.createElement("div", {
          className: "c-media__icon",
          key: infos.value
        }, /*#__PURE__*/React.createElement(Icon, {
          className: "c-media__icon-svg"
        }), /*#__PURE__*/React.createElement("span", {
          className: "c-media__icon-label"
        }, infos.short_label || infos.label || infos.value));
        return output;
      });
      let min_price = '';
      if (props.type === 'a_calm_coworking_space') {
        min_price = Object.keys(props.schedule_price || {}).reduce(function (lowest, field) {
          if (typeof lowest === 'undefined') {
            return numeral(safeNumeral(props.schedule_price[field]?.price)).value();
          } else if (props.schedule_price[field]?.price < lowest) {
            return numeral(safeNumeral(props.schedule_price[field]?.price)).value();
          }
          return lowest;
        }, undefined);
      } else if (props.type === 'b_seminar') {
        min_price = num(props.disposition_seat?.price_half_day);
        if (num(props.disposition_seat?.price_day) < min_price) {
          min_price = num(props.disposition_seat?.price_day);
        }
      }
      if (min_price > 0 === false) {
        min_price = 0;
      } else {
        min_price = numeral(min_price).format('0,0[.]00').split(',').join(' ');
      }
      let max_price = '';
      if (props.type === 'a_calm_coworking_space') {
        max_price = Object.keys(props.schedule_price || {}).reduce(function (max, field) {
          if (typeof max === 'undefined') {
            return numeral(safeNumeral(props.schedule_price[field]?.price)).value();
          } else if (props.schedule_price[field]?.price > max) {
            return numeral(safeNumeral(props.schedule_price[field]?.price)).value();
          }
          return max;
        }, undefined);
      }
      if (max_price > 0 === false) {
        max_price = 0;
      } else {
        max_price = numeral(max_price).format('0,0[.]00').split(',').join(' ');
      }
      const min_max_seats = props.min_max_seats.min !== props.min_max_seats.max ? props.min_max_seats.min + ' - ' + props.min_max_seats.max : props.min_max_seats.min;
      let b_seminars_seats = [];
      if (props.type === 'b_seminar') {
        b_seminars_seats = Object.keys(b_seminars_config).filter(name => props.disposition_seat?.[name]?.place > 0).map(function (name) {
          const config = b_seminars_config[name];
          const Icon = config.icon;
          const output = /*#__PURE__*/React.createElement("div", {
            className: "c-media__icon",
            key: name,
            "data-hover": config.title
          }, Icon ? /*#__PURE__*/React.createElement(Icon, {
            className: "c-media__icon-svg"
          }) : /*#__PURE__*/React.createElement("div", {
            className: 'c-media__seats-icon ' + name
          }, b_seminars_config[name].short_title), /*#__PURE__*/React.createElement("span", {
            className: "c-media__icon-label"
          }, props.disposition_seat[name].place, " pers."));
          return output;
        });
      }
      let seats_section = b_seminars_seats.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "c-media__icons people b_seminar-people"
      }, b_seminars_seats) : /*#__PURE__*/React.createElement("div", {
        className: "c-media__icons people"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-media__icon"
      }, /*#__PURE__*/React.createElement(PeopleIcon, {
        className: "c-media__icon-svg"
      }), /*#__PURE__*/React.createElement("span", {
        className: "c-media__icon-label"
      }, min_max_seats, ' ', props.type !== 'c_open_coworking_space' ? 'pers. par réservation' : 'pers.')));
      let schedule;
      if (props.schedule_hours) {
        schedule = /*#__PURE__*/React.createElement("div", {
          className: bemit('c-infos-label')
        }, /*#__PURE__*/React.createElement("div", {
          className: "c-infos-label__title"
        }, "Horaires"), "\xA0: ", props.schedule_hours[0], 'h00 - ', " ", props.schedule_hours[1], 'h00');
      }
      const img = props.images?.[0]?.url ? props.images[0] : undefined;
      let img_area;
      if (props['space-infos-hidden']) {
        img_area = null;
      } else if (props['white-label-booking']) {
        const gallery_btn = props.images?.length > 1 ? /*#__PURE__*/React.createElement("div", {
          className: "c-front-page-intro__galerie"
        }, /*#__PURE__*/React.createElement(Button, {
          className: "c-front-page-intro__btn\r c-front-page-intro__btn--direct-booking",
          onClick: component.openModal
        }, /*#__PURE__*/React.createElement(PhotoIcon, {
          className: "c-front-page-intro__address-icon"
        }), "Galerie")) : undefined;
        img_area = /*#__PURE__*/React.createElement("div", {
          className: "c-media__img-container"
        }, img ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Image, {
          className: "c-media__img",
          src: variant({
            img: props.images[0],
            size: 600
          }),
          alt: props.name
        }), gallery_btn) : /*#__PURE__*/React.createElement(Logo, {
          className: "c-media__img is-myWO-logo"
        }));
      } else {
        const image = props.images?.[0] ? /*#__PURE__*/React.createElement(Image, {
          className: "c-media__img",
          src: variant({
            img: props.images[0],
            size: 600
          }),
          alt: props.name
        }) : /*#__PURE__*/React.createElement(Logo, {
          className: "c-media__img"
        });
        img_area = props.source === 'offline' ? /*#__PURE__*/React.createElement("div", {
          className: "c-media__img-container"
        }, image) : /*#__PURE__*/React.createElement(Link, {
          href: link,
          className: "c-media__img-container",
          title: "Aller \xE0 l'espace"
        }, image);
      }
      let price_infos = !min_price || user_roles.includes('company_employee') ? undefined : props.type === 'a_calm_coworking_space' ? /*#__PURE__*/React.createElement("div", {
        className: "c-media__price-infos"
      }, max_price !== min_price ? 'De ' : undefined, /*#__PURE__*/React.createElement("span", {
        className: "c-media__price-value"
      }, min_price, max_price === min_price ? ' €/heure' : undefined, max_price === min_price ? /*#__PURE__*/React.createElement("span", {
        className: "c-media__price-asterix"
      }, ' *') : undefined), max_price !== min_price ? ' à ' : undefined, max_price !== min_price ? /*#__PURE__*/React.createElement("span", {
        className: "c-media__price-value"
      }, max_price, "\xA0\u20AC/heure", /*#__PURE__*/React.createElement("span", {
        className: "c-media__price-asterix"
      }, ' *')) : undefined, /*#__PURE__*/React.createElement("span", {
        className: "c-media__price-small-info"
      }, '*', " Les tarifs peuvent varier en fonction de la p\xE9riode")) : props.type === 'b_seminar' ? /*#__PURE__*/React.createElement("div", {
        className: "c-media__price-infos"
      }, props.disposition_seat?.price_half_day > 0 ? 'Demi journée :' : undefined, props.disposition_seat?.price_half_day > 0 ? /*#__PURE__*/React.createElement("span", {
        className: "c-media__price-value"
      }, formatNum(props.disposition_seat?.price_half_day, '0,0[.]00'), "\u20AC", /*#__PURE__*/React.createElement("span", {
        className: "c-media__price-asterix"
      }, ' *')) : undefined, props.disposition_seat?.price_half_day > 0 && props.disposition_seat?.price_day > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "u-full-width u-margin-bottom-10"
      }) : undefined, props.disposition_seat?.price_day > 0 ? 'Journée :' : undefined, props.disposition_seat?.price_day > 0 ? /*#__PURE__*/React.createElement("span", {
        className: "c-media__price-value"
      }, formatNum(props.disposition_seat?.price_day, '0,0[.]00'), "\u20AC", /*#__PURE__*/React.createElement("span", {
        className: "c-media__price-asterix"
      }, ' *')) : undefined, /*#__PURE__*/React.createElement("span", {
        className: "c-media__price-small-info"
      }, '*', " Les tarifs peuvent varier en fonction de la p\xE9riode")) : /*#__PURE__*/React.createElement("div", {
        className: "c-media__price-infos"
      });
      const output = /*#__PURE__*/React.createElement("div", {
        className: bemit('c-media', modifiers)
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-media__content"
      }, img_area, /*#__PURE__*/React.createElement("div", {
        className: "c-media__texts"
      }, /*#__PURE__*/React.createElement("h2", {
        href: link,
        className: "c-media__title"
      }, props['white-label-booking'] ? /*#__PURE__*/React.createElement("div", {
        href: link,
        className: "c-media__title-link"
      }, props.name) : /*#__PURE__*/React.createElement(Link, {
        href: link,
        className: "c-media__title-link"
      }, props.name)), /*#__PURE__*/React.createElement("div", {
        className: "c-media__subtitle"
      }, type?.front_label), seats_section, props['white-label-booking'] ? schedule ? schedule : props.schedule ? /*#__PURE__*/React.createElement(FrontSpaceSchedule, props.schedule) : undefined : undefined, /*#__PURE__*/React.createElement("div", {
        className: "c-media__icons"
      }, icons), props['white-label-booking'] ? /*#__PURE__*/React.createElement("div", {
        className: "c-media__description"
      }, description) : undefined, /*#__PURE__*/React.createElement("div", {
        className: "c-media__footer"
      }, price_infos), props.type !== 'c_open_coworking_space' ? undefined : isTrue(props.custom_free_conditions) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("em", {
        className: "c-media__special-txt"
      }, "Un forfait de consommations d\u2019un montant de ", formatNum(props.custom_free_price, '0,0[.]00'), "\xA0\u20AC vous sera demand\xE9 \xE0 l\u2019arriv\xE9e pour une demi-journ\xE9e. Il comprend\xA0: ", props.custom_free_text)) : /*#__PURE__*/React.createElement("em", {
        className: "c-media__special-txt"
      }, "Sous r\xE9serve de consommation et de places")), availability), /*#__PURE__*/React.createElement(FullScreenModal, {
        open: state.modal,
        className: "spaces",
        onClose: component.closeModal,
        trigger_src: state.modal_trg
      }, state.background && state.images?.length > 1 === false ? /*#__PURE__*/React.createElement(Image, {
        className: "c-front-page-intro__bg",
        src: state.background,
        alt: 'Illustration ' + state.title
      }) : state.slider_imgs ? /*#__PURE__*/React.createElement("div", {
        className: "c-front-page-intro__slider-container"
      }, /*#__PURE__*/React.createElement(Slider, {
        images: state.slider_imgs,
        bemit: ['fill-height', 'spaces'],
        key: state.pathname,
        "with-overlay": true
      })) : undefined));
      return output;
    } else if (props['layout-type'] === 'availability-only') {
      const output = /*#__PURE__*/React.createElement(Fragment, null, availability);
      return output;
    }
    const img_area = !props['space-infos-hidden'] ? /*#__PURE__*/React.createElement("div", {
      className: "c-media__img-container"
    }, props.images?.[0] ? /*#__PURE__*/React.createElement(Image, {
      className: "c-media__img",
      src: variant({
        img: props.images[0],
        size: 600
      }),
      alt: props.name
    }) : /*#__PURE__*/React.createElement(Logo, {
      className: "c-media__img"
    })) : undefined;
    let output = /*#__PURE__*/React.createElement(Link, {
      className: bemit('c-media', modifiers),
      href: link
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-media__content"
    }, img_area, /*#__PURE__*/React.createElement("div", {
      className: "c-media__texts"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-media__title"
    }, props.name))));
    return output;
  }
}
